import AbstractPayDef from "./AbstractPayDef";
import { CommonCheckoutSettings } from "@cs-ts/common-checkout-settings";
import { BaseElementDefBase, LockAction } from "./BaseElementDef";
import { FormItem } from "@cs/FormItem";
import { FormDefinitionItem } from "@/public/pages/elements/__DefinitionDataInterface";
import type { ICustomConfirmElement } from "./BaseElementDef";
import { CalculationContext } from "./__CalculationContextInterface";

export default class CommonCheckoutDef extends AbstractPayDef<CommonCheckoutSettings> implements ICustomConfirmElement {
    constructor(parentElement: BaseElementDefBase | null, elementData: FormItem, definitionData: FormDefinitionItem<CommonCheckoutSettings>, calculationContext: CalculationContext) {
        super(parentElement, elementData, definitionData, calculationContext);
        this.typeName = "MI.Common.DynamicForms.Models.DFCommonCheckout"; // TODO - not hardcoded?
    }

    getLockActions(lock: string): LockAction[] {
        return [
            {
                label: "Return to payment",
                redirectUrl: async () => {
                    const result = await this.invokeAsync("PaymentResumeUrl", lock, i => {
                        i.noWrite = false;
                        i.unlock = true;
                        return i;
                    });
                    return result as { alreadyUnlocked?: true; redirectUrl?: string };
                },
            },
            {
                label: "Cancel payment and resume editing this submission",
                unlock: true,
            },
        ];
    }

    hasCustomConfirmComponent(adminPreview: boolean) {
        return adminPreview;
    }

    async getCustomConfirmComponent(adminPreview: boolean) {
        if (adminPreview) {
            const func = (await import(/* webpackChunkName: "PageAdmin" */ "./CommonCheckoutDef.Admin")).getCustomConfirmComponent;
            return await func.apply(this, []);
        } else {
            throw new Error();
        }
    }
}
